import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import HomeCogGraphic from './HomeCogGraphic';

const HomeHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                {/* <div className="lp-badge lp-badge--up" data-lp-reveal><span />AI-powered transaction readiness</div> */}
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Rigorous diligence.<br />Days, not months.<br /><span style={{ color: '#FC7785' }}>£1,000, not £40,000.</span></h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">70% of SME investment/exit transactions historically not diligenced due to cost. <br /> Diligentsia changes that. AI-powered, human-verified transaction readiness for companies, advisors, and investors across the UK SME ecosystem.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary lp-btn--stacked" to={ROUTES.REGISTER}>
                        <span className="lp-btn-title">Get started free</span>
                        <span className="lp-btn-sub">No credit card required</span>
                    </Link>
                </div>
                <div className="lp-vc-dealcard lp-float" data-lp-reveal data-lp-delay="200" style={{ marginTop: "30px" }}>
                    <div className="dc-top">
                        <span className="t">360° Deal View</span>
                        <span className="live">Live</span>
                    </div>
                    <div className="dc-group">
                        <div className="dc-label" style={{ color: '#FC7785' }}>Your 180°</div>
                        <div className="dc-row">
                            <span className="lbl">Pitch deck quality</span>
                            <span className="val" style={{ color: '#1F8A5B' }}>✓ Strong</span>
                        </div>
                    </div>
                    <div className="dc-group">
                        <div className="dc-label" style={{ color: '#4A67FF' }}>The other 180° — Diligentsia</div>
                        <div className="dc-row">
                            <span className="lbl">Corporate governance</span>
                            <span className="val" style={{ color: '#FC7785' }}>⚠ 2 gaps</span>
                        </div>
                    </div>
                </div>
                {/* <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#FC7785', display: 'inline-block', flex: 'none' }} />
                    Trusted by 50+ investors, advisors, and growing companies · No credit card required
                </div> */}
            </div>

            <div className="lp-hero-art">
                <HomeCogGraphic />
            </div>
        </div>
    </section>
);

export default HomeHeroSection;
